import { YearDropdown as YearDropdownBase, YearSelectionRole } from "@atlas-int/controls";
import { memo } from "react";
import { SelectSkeleton } from "@atlas-int/ui";
import { useExploreParams } from "../../../visualization/paramSchemas";
import { useDataAvailability } from "@atlas-int/data";

export { YearSelectionRole };

interface YearSelectBoxInput {
  yearSelectionRole: YearSelectionRole;
}

const YearDropdown = ({ yearSelectionRole }: YearSelectBoxInput) => {
  const [
    {
      year,
      productClass,
      startYear,
      endYear,
    },
    setQuery,
  ] = useExploreParams();

  const { getYearRangeForProductClass, loading } = useDataAvailability();
  const yearRange = getYearRangeForProductClass(productClass);

  if (loading || !yearRange) {
    return <SelectSkeleton />;
  }

  let value: number | undefined;
  let onChange: (year: number) => void;

  if (yearSelectionRole === YearSelectionRole.FixedYear) {
    value = year ?? undefined;
    onChange = (y) => setQuery({ year: y });
  } else if (yearSelectionRole === YearSelectionRole.StartYear) {
    value = startYear ?? undefined;
    onChange = (y) => setQuery({ startYear: y });
  } else {
    value = endYear ?? undefined;
    onChange = (y) => setQuery({ endYear: y });
  }

  return (
    <YearDropdownBase
      value={value}
      onChange={onChange}
      yearMin={yearRange.yearMin}
      yearMax={yearRange.yearMax}
    />
  );
};

export default memo(YearDropdown);
